__turbopack_context__.v({
  "footerContent": "Footer-module-scss-module__0wuuHa__footerContent",
  "footerNav": "Footer-module-scss-module__0wuuHa__footerNav",
  "listingsFooter": "Footer-module-scss-module__0wuuHa__listingsFooter",
});
